import { createFileRoute } from "@tanstack/react-router"
import { CreateEventPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/create"
)({
  component: () => (
    <AuthorizationGate resource={Resource.EVENT} action={Action.CREATE}>
      <CreateEventPage />
    </AuthorizationGate>
  ),
})
